import { render, staticRenderFns } from "./VideoLlamada.vue?vue&type=template&id=306b7b9c"
import script from "./VideoLlamada.vue?vue&type=script&lang=js"
export * from "./VideoLlamada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports